import { render, staticRenderFns } from "./MusicTrack.vue?vue&type=template&id=0784acb4&scoped=true"
import script from "./MusicTrack.vue?vue&type=script&lang=js"
export * from "./MusicTrack.vue?vue&type=script&lang=js"
import style0 from "./MusicTrack.vue?vue&type=style&index=0&id=0784acb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784acb4",
  null
  
)

export default component.exports